import styled, { css } from 'styled-components'
import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import { respondAbove } from 'styles/mediaQueries'
import leftdecor from 'assets/icons/leftdecor.svg'

interface WrapperProps {
    isChosen?: boolean
    isSingleRenewed?: boolean
}

export const Wrapper = styled(Box)<WrapperProps>`
    position: relative;

    background-color: ${({ theme, isChosen, isSingleRenewed }) => {
        if (isSingleRenewed) return 'transparent'
        if (isChosen)
            return theme.mode === 'dark'
                ? theme.colors.darkmode_500
                : theme.colors.grayscale_0
        return theme.colors.grayscale_200
    }};

    ${({ theme, isChosen, isSingleRenewed }) => {
        if (!isSingleRenewed)
            return `
                border: 2px solid ${
                    isChosen
                        ? theme.colors.primary_500
                        : theme.colors.grayscale_200
                };
                border-radius: 8px;
            `
    }}

    width: 100%;
    ${({ isSingleRenewed }) => {
        if (!isSingleRenewed)
            return css`
                @media ${respondAbove.xl} {
                    max-width: 347px;
                }
            `
    }}

    ${({ isSingleRenewed }) => {
        if (isSingleRenewed) return 'padding: 0 0 16px;'
    }}

    transition: background-color 100ms ease-in, border-color 100ms ease-in;
`

interface HeaderWrapperProps {
    isRenewed?: boolean
    isPlus?: boolean
    isSingleRenewed?: boolean
}

export const HeaderWrapper = styled(Box)<HeaderWrapperProps>`
    ${({ isSingleRenewed }) => {
        if (isSingleRenewed)
            return css`
                padding-bottom: 16px;
                flex-direction: column;
                align-items: flex-start;
                @media ${respondAbove.xl} {
                    flex-direction: row;
                    align-items: flex-end;
                }
            `
        return css`
            flex-direction: column;
            align-items: flex-start;
            padding-bottom: 24px;
            @media ${respondAbove.xl} {
                padding-bottom: 32px;
            }
        `
    }}

    justify-content: ${({ isSingleRenewed }) =>
        isSingleRenewed ? 'space-between' : 'initial'};

    border-bottom: 2px solid
        ${({ theme, isSingleRenewed }) =>
            isSingleRenewed
                ? theme.colors.grayscale_300
                : theme.colors.grayscale_400};

    ${({ isSingleRenewed, isRenewed, isPlus }) => {
        if (isSingleRenewed)
            return css`
                & > p {
                    margin-bottom: 32px;
                    font-size: 24px;
                    line-height: 30px;
                    @media ${respondAbove.xl} {
                        margin-bottom: 6px;
                    }
                }
            `
    }}
    ${({ isRenewed }) => {
        if (isRenewed)
            return css`
                button {
                    padding-left: 16px;
                    padding-right: 16px;
                }
            `
    }}
`

interface PriceWrapperProps {
    isSingleRenewed?: boolean
}

export const PriceWrapper = styled(Box)<PriceWrapperProps>`
    align-items: baseline;

    ${({ isSingleRenewed }) => {
        if (isSingleRenewed)
            return css`
                margin: 0;
            `
        return css`
            margin: 24px 0 16px;
            @media ${respondAbove.xl} {
                margin: 32px 0 16px;
            }
        `
    }}
    ${Text} {
        flex-shrink: 0;
    }
`

interface ZonesWrapperProps {
    isSingleRenewed?: boolean
}

export const ZonesWrapper = styled(Box)<ZonesWrapperProps>`
    border-top: 2px solid
        ${({ theme, isSingleRenewed }) =>
            isSingleRenewed
                ? theme.colors.grayscale_300
                : theme.colors.grayscale_400};
`

export const Image = styled.img`
    height: 42px;
    width: 100%;
`
export const Flag = styled(Box)`
    position: absolute;
    right: -4px;
    top: 48px;
    min-width: 72px;
    height: 26px;
    background-color: ${({ theme }) => theme.colors.primary_500};
    justify-content: center;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    text-align: center;
    padding: 5px;

    @media ${respondAbove.xl} {
        top: 54px;
    }

    &::before {
        content: url(${leftdecor});
        position: absolute;
        top: 0;
        left: -10px;
        zoom: 0.94;

        @media ${respondAbove.xl} {
            zoom: 1;
        }
    }

    @media ${respondAbove.xl} {
        min-width: 69px;
        height: 28px;
    }
`
export const CardsWrapper = styled(Box)`
    flex-direction: column;

    ${Wrapper} {
        margin-bottom: 16px;
    }
    & ${Wrapper}:last-child {
        margin-bottom: 0;
    }

    @media ${respondAbove.xl} {
        flex-direction: row;
        justify-content: space-between;
        align-items: stretch;

        ${Wrapper} {
            margin-bottom: 0;
        }
    }
`
